import { Component } from '@angular/core';
import { LocationService } from '../../shared/location.service';
import { Incident } from '../../models/incident';
import { NotificationService } from '../../shared/notification.service';
import { AppModule } from "../../app.module";
import { IncidentType } from '../../shared/enums';
import { WebsocketsService } from '../../shared/websockets.service';
import { AuthService } from '../../auth.service';
import { SocketMessage, SocketMessageType } from '../../models/websocket';
import { IncidentService } from '../../shared/incident.service';
import { Driver } from '../../models/client';

@Component({
  selector: 'app-driver-dash',
  imports: [AppModule],
  templateUrl: './driver-dash.html',
  styleUrl: './driver-dash.less'
})
export class DriverDash {

  public breakdown: Incident = new Incident();
  public incidentType = IncidentType;
  public isLoading: boolean = false;
  public isNewIncidentModalVisible: boolean = false;

  public hasIncident: boolean = false;

  constructor(
    private locationService: LocationService, 
    private notification: NotificationService, 
    private websocketsService: WebsocketsService,
    private authService: AuthService,
    public incidentService: IncidentService
  ) {}


  public onClickNewBreakdown(): void {
    this.isLoading = true;
    // Logic for handling new breakdown click
    this.locationService.getPosition().subscribe({
      next: (position: GeolocationPosition) => {
        this.breakdown = new Incident();
        this.breakdown.location = {
          incidentId: 0,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          description: '',
          descriptionShort: ''
        };
        this.isLoading = false;
        this.isNewIncidentModalVisible = true;
      },
      error: (error) => {
        this.notification.showError('Failed to get current location');
        this.breakdown = new Incident();
        this.isNewIncidentModalVisible = true;
        this.isLoading = false;
      }
    });
  }

  public onSelectIncidentType(type: IncidentType): void {
    this.breakdown.incidentType = type;
  }

  public onClickAddNewIncident(): void {
    
    this.isNewIncidentModalVisible = false;
    this.isLoading = true;
    this.breakdown.driver = new Driver();
    this.breakdown.driver.driverId = this.authService.user?.userId || 0;
    this.breakdown.clientId = this.authService.user?.clientId || 0;
    //create new incident
    // const newBreakdownMessage = new SocketMessage();
    // newBreakdownMessage.type = SocketMessageType.CreateIncident;
    // newBreakdownMessage.message = JSON.stringify(this.breakdown);
    // this.websocketsService.SendMessage(newBreakdownMessage);
    this.incidentService.createIncident(this.breakdown).subscribe({
      next: (incident: Incident) => {
        this.notification.showSuccess('Breakdown Logged. Please stand by.');
        this.incidentService.DriverIncident = incident;
        this.hasIncident = true;
      },
      error: (error) => {
        this.notification.showError('Failed to create breakdown');
      }
    });

    this.isLoading = false;
  }

}
